import React from 'react';
import { Trans } from 'react-i18next';
import './TipBuyer.scss';

export interface TipBuyerButtonProps {
  onClick: (e: React.MouseEvent) => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
  className?: string;
  disabled?: boolean;
}

/**
 * The "Suggest" pill that opens the tip-buyer menu. `disabled` lets a host
 * block it, e.g. on the viewer's own buy listing where a tip would go to
 * themselves.
 */
export const TipBuyerButton: React.FC<TipBuyerButtonProps> = ({
  onClick,
  buttonRef,
  className = '',
  disabled = false,
}) => {
  return (
    <button
      className={`tip-buyer-button ${className}`.trim()}
      onClick={onClick}
      ref={buttonRef}
      disabled={disabled}
    >
      <span className={`tip-buyer-button__text ${className.includes('search-result-card') ? 'tip-buyer-button__text--search-result-card' : ''}`.trim()}>
        <Trans i18nKey="tipBuyer.button">Suggest</Trans>
      </span>
    </button>
  );
};
